module.exports = __webpack_public_path__ + "img/shein.c0fc7338.svg";